export default "__VITE_ASSET__Ca5bx3fM__"